export default __webpack_public_path__ + "static/media/idea.3456a373.svg";